import { Typography } from '@mui/material';
import { useIntl } from 'react-intl';

export const NewMessageIndicator = (props: { onClick: () => void }) => {
  const intl = useIntl();
  return (
    <Typography
      onClick={props.onClick}
      color='primary'
      sx={{
        cursor: 'pointer',
        fontSize: 14,
        fontWeight: 500,
        bgcolor: 'white',
        px: 5,
        py: 2,
        position: 'fixed',
        alignSelf: 'center',
        borderRadius: 5,
        boxShadow:
          '0 12px 16px 0 rgba(59, 69, 89, 0.05), 0 8px 10px 0 rgba(59, 69, 89, 0.1)',
      }}
    >
      {intl.formatMessage({ id: 'care-team.new-message' })}
    </Typography>
  );
};
